import React from 'react';
import { Section } from '../../shared/enums/container';
import { useI18n } from '../../shared/hooks/useI18n';
import { BigSection } from '../../shared/templates/BigSection';
import { FaqSection } from '../../shared/templates/FaqSection';
import { HeroSection } from '../../shared/templates/HeroSection';
import { JoinSection } from '../../shared/templates/JoinSection';
import { LastNewsSection } from '../../shared/templates/LastNewsSection';
import { MainContainer } from '../../shared/templates/MainContainer';
import { PlatformSection } from '../../shared/templates/PlatformSection';
import { StartSection } from '../../shared/templates/StartSection';
import { Document } from '../layout/Document/Document';
import { sourceTypeGenerator } from '../../util/source_type_generator.';
import { useConfig } from '../../config/context';
import {HeroSectionType} from "../../shared/templates/HeroSection/enum/hero-section-type";

function Ehealth(props: any) {
  const { data, posts, locale, supportedLocales, translation } = props.pageContext;
  const config = useConfig();
  const { t } = useI18n({
    locale,
    translation,
  });

  const ROLE_TABS = {
    patient: { title: t('patient') },
    doctor: { title: t('doctor') },
  };

  const circle = {
    data: {
      image: {
        avif: '/public-assets/img/doctors/circle.avif',
        png: '/public-assets/img/doctors/circle.avif',
        webp: '/public-assets/img/doctors/circle.webp'
      }
    }
  }


  data.how_to.item.map((item: any, key: number) => {
    item.image.webp = `/public-assets/img/patient/inside_step_${key + 1}.webp`
  })

  return (
    <Document t={t} locale={locale} supportedLocales={supportedLocales}>
      <MainContainer locales={supportedLocales} locale={locale} general_title={'ehealth_title'}>
        <HeroSection
          onClick={props.roleModalHandler}
          title={data.hero.title}
          button_text={data.hero.button_text}
          background_color={Section.HERO}
          heroSectionType={HeroSectionType.GENERAL}
        />

        <BigSection
          opportunityTitle={data.ability.title}
          src={'/public-assets/img/ehealth/ability.webp'}
          srcs={sourceTypeGenerator(data.ability.image)}
          iconWithText={data.ability.abilities}
          videoTitle={data.video.title}
          videoSrc={config.CONTENT.VIDEO.EHEALTH}
          videoInfo={data.counters}
          className={'ehealth'}
        />

        <FaqSection accordeon_data={data.faq.items} title={data.faq.title} />

        <StartSection
          title={data.how_to.title}
          steps={data.how_to.item}
          src={'/public-assets/img/doctors/circle.avif'}
          srcs={sourceTypeGenerator(circle.data.image)}
        />

        <PlatformSection
          title={data.app.title}
          srcPlatformMocap={sourceTypeGenerator(data.app.image)}
          src={'/public-assets/img/ehealth/app.webp'}
          benefits_description={data.app.columns}
        />

        <JoinSection
            title={data.register.title}
            locale={locale}
            description={data.register.description}
            tabs={ROLE_TABS}
            page='eHealth' />

        <LastNewsSection posts={posts} title={data.news.title} />
      </MainContainer>
    </Document>
  )
}

export default Ehealth;
